/**
 * 系统配置API服务
 *
 * @author page
 * @date 2026-08-04
 */
import {api} from './api';

export interface PocDisplayConfig {
    assistTradingEnabled: boolean;
    autoTradingEnabled: boolean;
    patternEnabled: boolean;
}

export interface PocConfigLog {
    id: number;
    operatorId: number;
    operatorName: string;
    assistTradingBefore: number;
    assistTradingAfter: number;
    autoTradingBefore: number;
    autoTradingAfter: number;
    patternBefore: number;
    patternAfter: number;
    changeTime: string;
    remark: string;
}

export interface PocConfigLogPage {
    records: PocConfigLog[];
    total: number;
    page: number;
    size: number;
}

export const systemConfigService = {
    /**
     * 获取POC展示配置
     */
    getPocDisplayConfig: () =>
        api.get<{ code: string; success: boolean; data: PocDisplayConfig }>('/api/v1/system/config/poc-display'),

    /**
     * 更新POC展示配置
     */
    updatePocDisplayConfig: (config: PocDisplayConfig) =>
        api.put<{ code: string; success: boolean; data: PocDisplayConfig; message: string }>(
            '/api/v1/system/config/poc-display',
            config
        ),

    /**
     * 获取POC配置变更日志（分页）
     */
    getPocConfigLogs: (page: number = 0, size: number = 10) =>
        api.get<{ code: string; success: boolean; data: PocConfigLogPage }>(
            '/api/v1/system/config/poc-display/logs',
            {params: {page, size}}
        ),
};
